import sliceReducer from "./reducers";

export { actions as notificationsActions } from "./slices";
export { selectors as notificationsSelectors } from "./slices";

export default sliceReducer;
